import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Row, Col, Avatar, Menu } from "antd";
import { Container, Card } from "react-bootstrap";

import "./style.css";

const routes = [
  {
    label: "Detail Akun",
    route: "/account/profile",
    icon: "far fa-user-circle",
  },
  {
    label: "Favorit",
    route: "/account/wishlist",
    icon: "far fa-heart",
  },
  {
    label: "Detail Penyewaan",
    route: "/account/rental-details",
    icon: "far fa-truck-couch",
  },
  {
    label: "Password",
    route: "/account/password",
    icon: "far fa-lock",
  },
];

const ProfileLayout = ({ children }) => {
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);

  return (
    <>
      <Container>
        <Card className="border-0 p-0 pt-3 mb-3">
          <Row gutter={[16, 0]}>
            <Col xxl={6} xl={6} lg={6} span={0}>
              <Card className="border-0">
                <div className="text-truncate text-dark align-middle text-decoration-none user-select-none">
                  <Avatar size="large" src={user && user.avatar} />
                  <span className="ps-2 align-middle fw-500 fs-16">{user && user.username}</span>
                </div>
                <hr />

                <Menu
                  mode="inline"
                  theme="light"
                  inlineIndent={15}
                  className="border-end-0 menu-profile"
                  selectedKeys={[history.location.pathname]}
                >
                  {routes.map((route) => (
                    <Menu.Item
                      key={route.route}
                      className="user-select-none"
                      onClick={() => history.push(route.route)}
                      icon={<i className={`${route.icon} mr-2`} />}
                    >
                      {route.label}
                    </Menu.Item>
                  ))}
                </Menu>
              </Card>
            </Col>

            <Col xxl={18} xl={18} lg={18} span={24}>
              {children}
            </Col>
          </Row>
        </Card>
      </Container>
    </>
  );
};

export default ProfileLayout;
